import { defineComponent } from 'vue';
import BlueCheckoutProductOverview from '@/components/BlueCheckout/ProductOverview.vue';
import AddressBlock from '@/components/BlueCheckout/AddressBlock.vue';
import PaymentTypeSelection from '@/components/BlueCheckout/PaymentTypeSelection.vue';
import CheckoutNewsletterSubscription from '@/components/Base/Newsletter/CheckoutNewsletterSubscription.vue';
import BlueCheckoutCheckoutBox from '@/components/BlueCheckout/CheckoutBox.vue';
import ShippingOptionSelection from '@/components/BlueCheckout/ShippingOptionSelection.vue';
import { mapGetters } from 'vuex';
import StickyCtaRow from '@/components/Base/StickyCtaRow.vue';
export default defineComponent({
    name: 'blue-checkout',
    components: {
        StickyCtaRow,
        ShippingOptionSelection,
        BlueCheckoutProductOverview,
        AddressBlock,
        PaymentTypeSelection,
        CheckoutNewsletterSubscription,
        BlueCheckoutCheckoutBox,
    },
    computed: Object.assign({}, mapGetters('account', {
        isLogin: 'isLogin',
    })),
    mounted() {
        // patch up href for needs login handling
        document.querySelectorAll('.needs_login').forEach((element) => {
            element.setAttribute('href', window.location.href);
        });
    },
});
